import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";

export class OrganizationSettingsInfoModel extends Model {
  constructor(
    public uuid: string | null = null,
    public name: string | null = null,
    public size: string = '',
  ) {
    super();
  }

  public static create(model: Partial<OrganizationSettingsInfoModel>): OrganizationSettingsInfoModel {
    return createModel<OrganizationSettingsInfoModel>(OrganizationSettingsInfoModel, {
      ...model
    });
  }
}
